import styled from "styled-components/macro";
import { colors } from "src/theme/colors";
import * as themeUi from "src/theme/ui";

/**
 * The panel's own name.
 *
 * The drawer had none: it opened on the first option's title, so the loudest
 * words on it were "Automated Transfer (UAE banks)" and nothing said what the
 * panel was or that there was a choice to make.
 */
export const Head = styled.h2`
  ${themeUi.text.hero}
  margin: 0;
  font-size: 18px;
  color: ${colors.gray[900]};
`;

export const Lead = styled.p`
  margin: 6px 0 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: ${colors.gray[500]};
`;

/* Stacked, and tight to each other. The two cards were 376px tall and spread
   by `justify-content: space-around` down a half-window drawer, so a hundred
   pixels of nothing sat between two choices that belong together. */
export const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
`;
